import React, { useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { ReactComponent as ChevronDownIcon } from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"

const LongLeadItemsSecond = () => {
  const chartRef = useRef(null);
  const theme = useTheme();

  const options = {
    chart: {
      type: "pie",
      height: 130,
      backgroundColor: "transparent",
    },
    colors: ["#3E756D", "#E72B33"],
    tooltip: {
      enabled: false,
    },
    title: {
      text: ""
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        startAngle: 220,
        innerSize: "60%",
        dataLabels: [
          {
            enabled: false,
          },
          {
            enabled: true,
            distance: -10,
            format: "{point.y}",
            style: {
              fontSize: "11px",
              fontWeight: 600,
              color: "#fff",
            },
          },
        ],
        showInLegend: true,
      },
    },
    series: [
      {
        name: "Registrations",
        data: [
          { name: "On Time", y: 13 },
          { name: "Delayed", y: 7 },
        ],
      },
    ],
    credits: {
      enabled: false,
    },
  };

  const CustomChevronIcon = (props) => (
              <ChevronDownIcon style={{ width: '16px', height: '16px' }} {...props} />
          );

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "auto", md: "178px" },
        borderRadius: "7px",
        overflow: "hidden",
        backgroundColor: "white",
        border: "1px solid #2525252E",
        p: 2,
      }}
    >
      {/* Heading and Dropdown */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
        }}
      >
        <Box sx={{ mb: { xs: 1.5, md: 0 } }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "500",
              fontSize: "18px",
              color: `${theme?.customSettings?.themeColor}`,
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          >
            Long Lead item - Aging Analysis
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#182A4E80",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          >
            {/* Get a holistic view of how work is being prioritised */}
          </Typography>
        </Box>
        <Select
          value={10}
          // IconComponent={IoIosArrowDown}
           IconComponent={CustomChevronIcon}
          sx={{
            backgroundColor: "#E8E8E8",
            mb: { xs: "15px", md: 0 },
            "& .MuiOutlinedInput-input": {
              padding: "5px 15px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          }}
        >
          <MenuItem value={10}>90 days - 150 days</MenuItem>
          <MenuItem value={1}>150 days - 250 days</MenuItem>
          <MenuItem value={2}>More than 250 days</MenuItem>
        </Select>
      </Box>


      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 0,
        }}
      >
        {/* Left Side: Text Section */}
        <Box sx={{ width: "50%", pl: 2, }}>
          <Typography
            variant="body2"
            sx={{
              display: "flex",           // <== Use flex to align items
              alignItems: "center",      // <== Center them vertically
              fontWeight: "500",
              color: "#182A4E",
              fontSize: "16px",
              letterSpacing: "-0.4px",
              mb: 2,
              "&::before": {
                content: '""',
                display: "inline-block",
                width: "14px",
                height: "14px",
                backgroundColor: "#3E756D",
                borderRadius: "0%",
                marginRight: "8px",
              },
            }}
          >
            Open since 15 Days:
            <span
              style={{
                fontWeight: "700",
                color: "#182A4E",
                fontSize: "16px",
                letterSpacing: "-0.4px",
                marginLeft: "8px",
              }}
            >
              13
            </span>
          </Typography>

          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              color: "#182A4E",
              fontSize: "16px",
              letterSpacing: "-0.4px",
              mb: 2,
              "&::before": {
                content: '""',
                display: "inline-block",
                width: "14px",
                height: "14px",
                backgroundColor: "#CE412D",
                borderRadius: "0%",
                marginRight: "8px",
              },
            }}
          >
            Open since 45 Days:
            <span
              style={{
                fontWeight: "700",
                color: "#182A4E",
                fontSize: "16px",
                letterSpacing: "-0.4px",
                marginLeft: "8px",
              }}
            >
              7
            </span>
          </Typography>

        </Box>

        {/* Right Side: Chart */}
        <Box sx={{ width: "50%" }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            ref={chartRef}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LongLeadItemsSecond;
